export default "__VITE_ASSET__DnHWJtVW__"